import React from 'react';
import { motion } from 'framer-motion';

const WhatsAppButton = ({ onClick }) => {
  const phoneNumber = '919093343536';
  const message = 'Hi, I am interested in your copper products. Can you provide more information?';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Contact us on WhatsApp"
    >
      <div className="relative">
        {/* Pulsing ring animation */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75"></div>
        
        {/* Main button with WhatsApp SVG icon */}
        <div className="relative flex items-center justify-center w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full shadow-2xl transition-all duration-300 group-hover:scale-110">
          <svg viewBox="0 0 32 32" className="w-9 h-9" fill="white">
            <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 8.16-2.141c2.329 1.323 4.972 2.021 7.683 2.021h0.157c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.333c-2.547 0-5.043-0.716-7.229-2.067l-0.517-0.308-5.367 1.407 1.429-5.301-0.344-0.537c-1.483-2.281-2.267-4.955-2.267-7.693 0-7.753 6.305-14.059 14.059-14.059s14.059 6.305 14.059 14.059-6.305 14.059-14.059 14.059z"></path>
            <path d="M23.407 19.843c-0.399-0.197-2.359-1.163-2.725-1.297-0.365-0.132-0.631-0.197-0.896 0.199-0.265 0.397-1.028 1.297-1.26 1.563s-0.464 0.297-0.863 0.1c-0.399-0.199-1.683-0.62-3.204-1.976-1.183-1.053-1.983-2.352-2.216-2.751-0.232-0.397-0.025-0.613 0.173-0.811 0.177-0.176 0.399-0.464 0.597-0.697 0.2-0.232 0.265-0.397 0.399-0.663 0.132-0.265 0.067-0.497-0.033-0.697s-0.896-2.159-1.228-2.956c-0.323-0.776-0.651-0.671-0.896-0.684-0.232-0.011-0.497-0.013-0.763-0.013s-0.696 0.099-1.063 0.497c-0.365 0.397-1.396 1.364-1.396 3.327s1.429 3.86 1.628 4.125c0.199 0.265 2.807 4.283 6.801 6.005 0.951 0.411 1.692 0.655 2.269 0.839 0.956 0.303 1.823 0.261 2.512 0.159 0.764-0.115 2.359-0.964 2.692-1.895 0.333-0.932 0.333-1.731 0.232-1.895-0.099-0.167-0.365-0.267-0.763-0.465z"></path>
          </svg>
        </div>
        
        {/* Tooltip */}
        <div className="absolute right-20 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <div className="bg-slate-900 text-white px-4 py-2 rounded-lg shadow-xl whitespace-nowrap text-sm">
            Chat with us on WhatsApp
            <div className="absolute right-0 top-1/2 transform translate-x-2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-slate-900"></div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;